module.exports = __webpack_public_path__ + "fonts/AftaSansThin-Regular.c6500138.eot";